import React from "react";
import "../../styles/footer.css"; // Importing the external CSS styles for the footer
import { NavLink } from "react-router-dom";

function Footer() {
  // Function to redirect to social media URLs
  const redirectToSocialMedia = (url) => {
    window.open(url, "_blank"); // Open the URL in a new tab
  };

  return (
    <div>
      <hr className="text-white" />
      <div className="footer">
        <div className="socials">
          <i
            className="fa fa-facebook"
            onClick={() => redirectToSocialMedia("https://www.facebook.com/")}
          ></i>
          <i
            className="fa-brands fa-google"
            onClick={() => redirectToSocialMedia("https://www.google.com/")}
          ></i>
          <i
            className="fa fa-twitter"
            onClick={() => redirectToSocialMedia("https://www.twitter.com/")}
          ></i>
          <i
            className="fa-brands fa-instagram"
            onClick={() => redirectToSocialMedia("https://www.instagram.com/")}
          ></i>
        </div>
      </div>
      <hr className="text-white" />
      <footer class="footer text-center text-lg-start bg-body-tertiary text-muted text-white">
        <section class="">
          <div class="container text-center text-md-start mt-5">
            {/* <!-- Grid row --> */}
            <div class="row mt-3">
              {/* <!-- Grid column --> */}
              <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                {/* <!-- Content --> */}
                <h6 class="text-white fw-bold mb-4">
                  <span>in</span>Force
                </h6>
                <p className="text-white">
                  Effortlessly navigate traffic laws, fines, and manage cases
                  with intuitive interfaces for various user roles.
                </p>
                <h6 className="text-white">
                  <i class="fa-solid fa-people-group"></i>
                  <NavLink to="/developer-team" target="_blank">
                    {" "}
                    Developer Team
                  </NavLink>
                </h6>
              </div>

              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                {/* <!-- Links --> */}
                <h6 class=" text-white text-uppercase fw-bold mb-4">Contact</h6>

                <p className="text-white">
                  <i class="fas fa-home me-3"></i> Chattogram
                </p>
                <p className="text-white">
                  <i class="fas fa-envelope me-3"></i>
                  dcdbcmp@police.gov.bd
                </p>
                <p className="text-white">
                  <i class="fas fa-phone me-3"></i> +880-1676123456
                </p>
              </div>
            </div>
          </div>
        </section>

        <div>
          <p class="fw-bold text-center p-4 text-white">
            &copy; All rights reserved to: Samiha & Ateka
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
